'use strict';

const ajax = require('../../modules/ajax'),
    slickSlider = require('../../slick-slider'),
    damHelper = require('../../dam/dam-helper'),
    socialCommerce = require('../../social-commerce/social-commerce'),
    getUpdatedURLWithParams = require('../../modules/util/getUpdatedURLWithParams'),
    responsiveVideo = require('../../responsive-video');

const updateStateAndUrlParams = (urlParams, paramsToRemove, skipHash) => {
    const newURL = getUpdatedURLWithParams(urlParams, paramsToRemove, skipHash);
    if (!newURL) {
        return;
    }

    window.history.replaceState({}, '', newURL);
    socialCommerce.updateCustomerLastUrl();
};

const updateAddToCartButton = (addToCartUrl) => {
    updateAddToCartButtonBlock(addToCartUrl, '.js-pdp-add-to-cart-form');
};

const updateStickyAddToCartButton = (stickyAddToCartUrl) => {
    updateAddToCartButtonBlock(stickyAddToCartUrl, '.js-sticky-add-to-cart-form');
};

const updateAddToCartButtonBlock = (url, targetClass) => {
    if (!url || !targetClass) {
        return;
    }

    const $updateTarget = $(targetClass);
    ajax.load({
        url: url,
        target: $updateTarget,
        replaceTarget: false,
    });
};

const updateImages = (urlImages, callback) => {
    if (!urlImages) {
        if (callback && $.isFunction(callback)) {
            callback();
        }
        return;
    }
    const targetClass = '.js-images-wrapper';
    const $updateTarget = $(targetClass);
    const $spinner = $('.js-pdp-images-spinner');

    $spinner.addClass('spinner-visible');

    ajax.load({
        url: urlImages,
        target: $updateTarget,
        replaceTarget: true,
        callback: function () {
            $spinner.removeClass('spinner-visible');
            $(targetClass).addClass('fade-out');
            damHelper.updateImages($('.js-images-wrapper'));
            damHelper.updateImages($('.js-pdp-swatches-list'));

            setTimeout(function() {
                $(targetClass).removeClass('fade-out');
                slickSlider.initDefaultSlider();
                $(document).trigger($.Event('productPage.onImageUpdate'));
                if (callback && $.isFunction(callback)) {
                    callback();
                }
            }, 100);
        }
    });
};

const updateProductDetailImage = (variationProductDetailImageUrl) => {
    updateImage(variationProductDetailImageUrl, '.js-product-info-column-image', '.js-product-info-image');
};

const updateProductLifestyleImage = (variationProductLifestyleImageUrl) => {
    updateImage(variationProductLifestyleImageUrl, '.js-product-ingredients-column-image', '.js-product-lifestyle-image');
};

const updateHowToUseImage = (howToUseImageUrl) => {
    updateImage(howToUseImageUrl, '.js-how-to-use-block', '.js-how-to-use-image');
};

const updateEasterARBlockImage = (arBlockImageUrl) => {
    updateImage(arBlockImageUrl, '.js-easter-ar-block', '.js-egg-image');
};

const updateStickyBarImage = (stickyBarImage) => {
    updateImage(stickyBarImage, '.js-sticky-add-to-cart', '.image');
};

const updateImage = (image, imageHolderClass, imageClass) => {
    if (!image || !imageHolderClass || !imageClass) {
        return;
    }

    const $imageHolder = $(imageHolderClass);
    const $target = $(imageClass, $imageHolder);
    if (!$imageHolder.length || !$target.length) {
        return;
    }
    if (Object.prototype.toString.call(image) === '[object Object]') {
        $target.attr('data-src', image.src);
        $target.attr('alt', image.alt);
    } else {
        $target.attr('data-src', image);
    }
    damHelper.updateImages($imageHolder);
};

const trimAndUpdateLongDescription = (usp) => {
    if (!usp) {
        return;
    }

    usp = usp.replaceAll(/[\n]/g,'<br>');
    updateTabsDescription(usp);
    usp = usp.replaceAll('<br>', '');

    const $longDescriptionElement = $('.js-long-description');
    if (!$longDescriptionElement || !$longDescriptionElement.length) {
        return;
    }

    if (usp.length <= 140) {
        $longDescriptionElement.text(usp);
        return;
    }

    const trimmedUSP = usp.substring(0, 137 - $('.js-read-more-link').text().length);
    const currentUSP = $longDescriptionElement.html();
    $longDescriptionElement.html(trimmedUSP + currentUSP.substring(currentUSP.indexOf('<'), currentUSP.length));
};

const updateShortDescription = (shortDescription) => {
    updateText(shortDescription, '.js-product-details-content .short-description');
};

const updateTitle = (title) => {
    updateText(title, '.js-product-details-block .product-name', true);
};


const updateProductTitle = (text) => {
    if (!text){ return;}
    $('.js-product-details-block .product-name').each(function() {
        const $contents = $(this).contents();
        $contents[$contents.length - 1].nodeValue = text;
    });
};

const updateFragrance = (fragrance) => {
    updateText(fragrance, '.scrub-variant');
};

const updateStickyBarTitle = (stickyBarTitle) => {
    updateText(stickyBarTitle, '.js-sticky-add-to-cart .product-name', true);
};

const updateAncientRituals = (ancientRituals) => {
    updateText(ancientRituals, '.js-product-details-block .js-the-ritual-of-title');
};

const updateStickyBarAncientRituals = (stickyBarAncientRituals) => {
    updateText(stickyBarAncientRituals, '.js-sticky-add-to-cart .js-the-ritual-of-title');
};

const updateInfoTitle = (infoTitle) => {
    updateText(infoTitle, '.js-info-title');
};

const updateInfoText = (infoText) => {
    updateText(infoText, '.js-info-description');
};

const updateHowToUseText = (howToUseText) => {
    updateText(howToUseText, '.js-how-to-use-block .js-how-to-use-text');
};

const updateText = (text, targetClass, preserveRituals) => {
    if (!text || !targetClass) {
        return;
    }

    const $target = $(targetClass);
    const $rituals = preserveRituals ? $target.find('span') : null;

    if (!$target || !$target.length) {
        return;
    }

    $target.html(text);
    if (preserveRituals && $rituals && $rituals.length) {
        $target.prepend($rituals);
    }
};

const updateClaimableIngredients = (claimableIngredients) => {
    if (!claimableIngredients) {
        return;
    }
    const $target = $('.product-ingredients-container .product-ingredients-content');
    if (!$target.length) {
        return;
    }
    let itemExposed = '';
    if ($target.children().filter('.ingredient-item-exposed').first()) {
        itemExposed = ' ingredient-item-exposed';
    }

    $target.empty();
    claimableIngredients.forEach(function(claimableIngredient){
        $target.append('<div class="ingredient-item' + itemExposed + '"><h3>' + claimableIngredient.Name + '</h3><p>' + claimableIngredient.Description + '</p></div>');
    });
};

const updateClaimableIngredient = (claimableIngredient) => {
    if (!claimableIngredient) {
        return;
    }
    const $target = $('.js-ingredient-item');
    if (!$target.length) {
        return;
    }
    $('.js-ingredient-title', $target).text(claimableIngredient.Name);
    $('.js-ingredient-text', $target).text(claimableIngredient.Description);
};

const updateChemicalIngredients = (chemicalIngredients) => {
    if (!chemicalIngredients) {
        return;
    }
    const $target = $('.js-ingredient-tab-content-inner .js-tab-expanding-content');
    if (!$target.length) {
        return;
    }
    $target.text(chemicalIngredients);
};

const updateTabsDescription = (tabsDescription) => {
    updateTabsText(tabsDescription, '.js-product-tabs .js-description-tab-content', '.js-product-tabs .js-description-acc-head');
};

const updateTabsIngredients = (chemicalIngredients) => {
    updateTabsText(chemicalIngredients, '.js-product-tabs .js-ingredients-tab-content .js-tab-expanding-content', '.js-product-tabs .js-ingredients-acc-head');
};

const updateTabsContents = (tabsContents) => {
    updateTabsText(tabsContents, '.js-product-tabs .js-contents-tab-content', '.js-product-tabs .js-contents-acc-head');
};

const updateTabsText = (tabsText, desktopSelector, mobileSelector) => {
    if (!tabsText || !desktopSelector || !mobileSelector) {
        return;
    }

    const $desktopTarget = $(desktopSelector);
    if ($desktopTarget && $desktopTarget.length) {
        $desktopTarget.html(tabsText);
    }
    const $mobileTarget = $(mobileSelector).next();
    if ($mobileTarget && $mobileTarget.length) {
        $mobileTarget.html(tabsText);
    }
};

const updateRitualsIcon = (ritualsIconUrl) => {
    const $target = $('.js-ritual-icon');
    if (!$target.length || !$target.length) {
        return;
    }

    if (!ritualsIconUrl) {
        $target.addClass('hide');
        return;
    }

    $target.attr('src', ritualsIconUrl);
    $target.removeClass('hide');
};

const updateBlocksWithColor = (selector, classToAdd, classesToRemove) => {
    if (!selector || !classToAdd) {
        return;
    }

    const $element = $(selector);
    if (!$element || !$element.length) {
        return;
    }

    if (classesToRemove || classesToRemove.length) {
        classesToRemove.forEach((cssClass) => {
            $element.removeClass(cssClass);
        });
    }

    $element.addClass(classToAdd);
};

const updateUSPs = (usps) => {
    if (!usps || Object.prototype.toString.call(usps) !== '[object Object]') {
        return;
    }

    for (const key in usps) {
        if (!usps[key]) {
            continue;
        }
        const $element = $('.js-selected-variant-' + key);
        if (!$element || !$element.length) {
            continue;
        }

        $element.text(usps[key]);
    }
};

const updateVideoSrc = (id, videoSrc) => {
    if (!id || !videoSrc) {
        return;
    }

    responsiveVideo.updateVideoSrc(id, videoSrc);
};

module.exports = {
    updateStickyBarImage: updateStickyBarImage,
    trimAndUpdateLongDescription: trimAndUpdateLongDescription,
    updateProductDetailImage: updateProductDetailImage,
    updateProductLifestyleImage: updateProductLifestyleImage,
    updateImages: updateImages,
    updateHowToUseImage: updateHowToUseImage,
    updateAddToCartButton: updateAddToCartButton,
    updateStickyAddToCartButton: updateStickyAddToCartButton,
    updateShortDescription: updateShortDescription,
    updateTitle: updateTitle,
    updateProductTitle:updateProductTitle,
    updateStickyBarTitle: updateStickyBarTitle,
    updateFragrance: updateFragrance,
    updateClaimableIngredients: updateClaimableIngredients,
    updateClaimableIngredient:updateClaimableIngredient,
    updateChemicalIngredients:updateChemicalIngredients,
    updateAncientRituals: updateAncientRituals,
    updateStickyBarAncientRituals: updateStickyBarAncientRituals,
    updateRitualsIcon: updateRitualsIcon,
    updateInfoTitle: updateInfoTitle,
    updateInfoText: updateInfoText,
    updateHowToUseText: updateHowToUseText,
    updateEasterARBlockImage: updateEasterARBlockImage,
    updateTabsIngredients: updateTabsIngredients,
    updateTabsDescription: updateTabsDescription,
    updateTabsContents: updateTabsContents,
    updateBlocksWithColor: updateBlocksWithColor,
    updateUSPs: updateUSPs,
    updateVideoSrc: updateVideoSrc,
    updateStateAndUrlParams: updateStateAndUrlParams
};
